/**
 * Canonical filter type values (stored in API / DB).
 * Legacy display labels are normalized when loading existing filters.
 */
export const FILTER_TYPE_OPTIONS = [
  { label: 'Drop Down', value: 'dropdown' },
  { label: 'Date Picker', value: 'datepicker' },
  { label: 'Tags', value: 'tags' },
  { label: 'Checklist', value: 'checklist' },
];

const LEGACY_FILTER_TYPE_MAP = {
  'Drop Down': 'dropdown',
  'Date Picker': 'datepicker',
  Tags: 'tags',
  Checklist: 'checklist',
};

const CANONICAL = new Set(['dropdown', 'datepicker', 'tags', 'checklist']);

export function normalizeFilterType(type) {
  if (type == null || type === '') return '';
  const s = String(type).trim();
  if (LEGACY_FILTER_TYPE_MAP[s]) return LEGACY_FILTER_TYPE_MAP[s];
  const compact = s.toLowerCase().replace(/\s+/g, '');
  if (CANONICAL.has(compact)) return compact;
  return s;
}

export function isFilterMultiSelect(type) {
  const n = normalizeFilterType(type);
  return n === 'tags' || n === 'dropdown';
}

export function isDatePickerFilterType(type) {
  return normalizeFilterType(type) === 'datepicker';
}
